// Libraries
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// Components
import ScrollToTop from './scroll-to-top';
import Header from '../../ui/navigation/header';
import Footer from '../../ui/navigation/footer';
import MainWrapper from '../main-wrapper';
import ModalRoot from '../../../containers/modal-root';

/**
 * Root Component
 * This is the App's Root component. It wraps every page within the main tag, with a Map underneath.
 *
 * @class Root
 * @extends {Component}
 */
class Root extends Component {
  render() {
    const { children } = this.props;

    return (
      <ScrollToTop>
        <Wrapper id="root">
          <Header />
          <MainWrapper>{children}</MainWrapper>
          <Footer />
          <ModalRoot />
        </Wrapper>
      </ScrollToTop>
    );
  }
}

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

Root.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default Root;



// WEBPACK FOOTER //
// ./src/components/general/root/index.jsx